import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import { showAlertDialog } from '../../shared/helpers/showAlertDialog';
import { AlertType } from '../../shared/models/alertType';

export interface PendingChangesAware {
  hasPendingChanges(): boolean;
}

export const pendingChangesGuard: CanDeactivateFn<PendingChangesAware> = (component) => {
  if (!component.hasPendingChanges()) {
    return true;
  }

  const dialog = inject(MatDialog);
  return showAlertDialog(
    dialog,
    AlertType.Warning,
    'Atenção!',
    'Você tem alterações não salvas. Deseja descartar as alterações?',
    'Descartar',
    'Cancelar',
  )
    .afterClosed()
    .pipe(map((confirmed) => !!confirmed));
};
